<template>
	<div style="margin: 10px;height: 200px;">
		<!-- :style="[{color: `${ color }`}]" -->
		<template v-if="typeUpload == 1">
			<div class="textCss" v-if="!UploadObj">
				{{ title }}
			</div>
			<div class="enclCss" @click="btnclick" v-if="!UploadObj">
				<img src="../assets/icon/UploadEnclosure.png" alt="">
				<div class="ImgTextCss">
					{{imgTitle}}
				</div>
			</div>
			<div v-else
				style="width: 270px; margin-left: 35px;display: inline-block;border: 1px solid rgb(45 39 39 / 14%);">
				<div style="margin-left: 250px;cursor: pointer;" @click="close">
					<img src="../assets/channel/firstbusiness/close-small.png" alt="" style="width: 20px;height: 20px;">
				</div>
				<img src="../assets/channel/DownLoadIcon/Ex_File.png" alt="" v-if="UploadObj.Extension == 'xlsx'"
					style="width: 50px; height: 50px; margin-top: -20px;margin-left: 100px;">
				<img src="../assets/channel/DownLoadIcon/P_File.png" alt="" v-if="UploadObj.Extension == 'ppt'"
					style="width: 50px; height: 50px; margin-top: -20px;margin-left: 100px;">
				<img src="../assets/channel/DownLoadIcon/Word_File.png" alt="" v-if="UploadObj.Extension == 'docx'"
					style="width: 50px; height: 50px; margin-top: -20px;margin-left: 100px;">
				<img src="../assets/channel/DownLoadIcon/O_File.png" alt="" v-if="UploadObj.Extension == 'OutLook'"
					style="width: 50px; height: 50px; margin-top: -20px;margin-left: 100px;">
				<img src="../assets/channel/DownLoadIcon/Pdf_File.png" alt="" v-if="UploadObj.Extension == 'pdf'"
					style="width: 50px; height: 50px; margin-top: -20px;margin-left: 100px;">
				<div style="width: 100%;text-align: center;">
					{{ UploadObj.FileName }}
				</div>
			</div>
			<div :style="[{ width: `${ opwidth }` , top: `${ top }` }]" class="bodis" v-if="optional">
			</div>
			<input ref="filElem" id="filElem" accept="*" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='multiple*'">
			<input ref="filElem" id="filElem" accept="*" type="file" class="upload-file" @change="getFile"
				style="display: none;" v-if="types=='file'">
			<input ref="filElem" id="filElem" accept=".png,.jpg" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='multiple'">
		</template>
		<template v-if="typeUpload == 2">
			<div style="typeUpload2">
				<div :style="[{fontWeight: `${ fontWeight }`}]" class="textCss2">
					{{ title }}
				</div>
				<!-- @mouseover="BLPhotomouseover" -->
				<div class="enclCss2" :style="enclCss2" @click="btnclick" v-if="BLPhotoURL == ''">
					<img src="../assets/icon/UploadEnclosure.png" alt="">
					<div class="ImgTextCss">
						{{imgTitle}}
					</div>
				</div>
				<!-- config.http_URL+ -->
				<div class="enclCss1" :style="enclCss1" v-if="BLPhotoURL != ''">
					<img :src="BLPhotoURL" alt="" style=" width: 120px;height: 120px;">
				</div>
				<div class="Mask" :style="Mask" v-if="BLPhotoURL != ''">
					<img src="../assets/channel/firstbusiness/phontsD.png" alt="" class="phontsD"
						@click="phontsPreviwe">
					<img src="../assets/channel/firstbusiness/phontsDel.png" alt="" class="phontsDel"
						@click="phontsPreviweDel">
				</div>
				<div class="MaskTop" v-if="BLPhotoURL != '' && MaskTopFlag">
				</div>
				<!-- <div class="remarks">
          支持上传jpg、jpeg、png格式的图片，最大支持5M
        </div>
        <slot></slot> -->
				<input ref="filElem" id="filElem" accept=".jpg,.png" type="file" class="upload-file" @change="getFile"
					style="display: none;" v-if="types=='file'">
				<input ref="filElem" id="filElem" accept=".png,.jpg" multiple="multiple" type="file" class="upload-file"
					@change="getFiles" style="display: none;" v-if="types=='multiple'">
			</div>

		</template>
		<template v-if="typeUpload == 3">
			<div style="typeUpload2">
				<div class="textCss2">
					{{ title }}
				</div>
				<!-- @mouseover="BLPhotomouseover" -->
				<div class="enclCss2" :style="enclCss2" @click="btnclick" v-if="BLPhotoURL == ''">
					<img src="../assets/icon/UploadEnclosure.png" alt="">
					<div class="ImgTextCss">
						{{imgTitle}}
					</div>
				</div>
				<!-- config.http_URL+ -->
				<div class="enclCss1" :style="enclCss1" v-if="BLPhotoURL != ''">
					<img :src="BLPhotoURL" alt="" style=" width: 120px;height: 120px;">
				</div>
				<div class="Mask" :style="Mask" v-if="BLPhotoURL != ''">
					<img src="../assets/channel/firstbusiness/phontsD.png" alt="" class="phontsDLook"
						@click="phontsPreviwe">
				</div>
				<div class="MaskTop" v-if="BLPhotoURL != '' && MaskTopFlag">
				</div>
			</div>

		</template>
		<Picturepreview :show="shows" :imgsrc="BLPhotoURL" @hidefn="phontsPreviwehidefn"></Picturepreview>
	</div>
</template>

<script>
	import Picturepreview from '../components/picturepreview.vue'
	import config from '../config/confighttp'
	export default {
		components: {
			Picturepreview
		},
		props: {
			//文字颜色
			color: {
				type: String,
				default: '#000'
			},
			// 按钮宽度
			width: {
				type: String,
				default: '100%'
			},
			// 按钮高度
			height: {
				type: String,
				default: '32px'
			},
			// 按钮文本
			title: {
				type: String,
				default: '附件:'
			},
			imgTitle: {
				type: String,
				default: '上传附件'
			},
			// 文字大小
			fontSize: {
				type: String,
				default: '2px'
			},
			// 按钮背景色
			backgroundColor: {
				type: String,
				default: '#E6E6E6'
			},
			// icon路径
			src: {
				type: String,
				default: ''
			},
			// 控制也用和禁用
			optional: {
				type: Boolean,
				default: false
			},
			// 禁用蒙版的宽度
			opwidth: {
				type: String,
				default: '68px'
			},
			// 禁用蒙版的定位
			top: {
				type: String,
				default: '222px'
			},
			types: {
				type: String,
				default: 'file'
			},
			typeUpload: {
				type: Number,
				default: 1
			},
			BLPhotoURL: {
				type: String,
				default: ''
			},
			MaskTopFlag: {
				type: Boolean,
				default: false
			},
			UploadObj: {
				type: Object
			},
			enclCss1: {
				type: String,
			},
			enclCss2: {
				type: String,
			},
			Mask: {
				type: String,
			},
			fontWeight: {
				type: Number,
				default: 600
			}
		},
		data: function() {
			return {
				phontsD: true,
				shows: false,
				config: null
			}
		},
		created() {

		},
		mounted() {
			this.config = JSON.parse(JSON.stringify(config))
		},
		methods: {
			// BLPhotomouseover() {
			//   this.phontsD = !this.phontsD
			// },
			close() {
				this.UploadObj = ''
			},
			// 打开弹窗
			phontsPreviwe() {
				this.shows = true
			},
			// 关闭弹窗
			phontsPreviwehidefn() {
				this.shows = false
			},
			// 删除照片
			phontsPreviweDel() {
				this.BLPhotoURL = ''
				this.phontsD = false
			},
			btnclick() {
				this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
			},
			getFile(e) {
				// const loading = this.$loading({
				//   lock: true,
				//   text: '正在上传...',
				//   spinner: 'el-icon-loading',
				//   background: 'rgba(255,255,255,0.3)'
				// });
				const inputFile = e.target.files[0];
				this.$emit('getFile', inputFile)
				// input[file]标签防重复问题
				e.target.value = ""
			},
			getFiles(e) {

				const inputFile = e.target.files;
				this.$emit('getFiles', inputFile)
				// input[file]标签防重复问题
				e.target.value = ""
			},
		},
		watch: {
			BLPhotoURL(newVal, oldVal) {
				this.BLPhotoURL = newVal
			}
		}
	}
</script>

<style lang="less">
	.typeUpload2 {
		overflow: hidden;
		position: relative;
	}

	.remarks {
		font-size: 14px;
		color: #9ca5b8;
		position: relative;
		left: 25px;
		margin-top: -110px;
	}

	.enclCss {
		width: 120px;
		height: 120px;
		background-color: #f7f8fa;
		border: 1px dashed #d4d6d9;
		border-radius: 2px;
		cursor: pointer;
		display: inline-block;
		margin-left: 35px;
		position: relative;
		user-select: none;

		img {
			margin-top: calc(80px / 2);
			margin-left: calc(100px / 2);
		}

		.ImgTextCss {
			font-size: 14px;
			font-family: "微软雅黑";
			color: rgb(51, 51, 51);
			margin-left: 30px;
			margin-top: 5px;
		}
	}

	.enclCss2 {
		width: 120px;
		height: 120px;
		background-color: #f7f8fa;
		border: 1px dashed #d4d6d9;
		border-radius: 2px;
		font-weight: 600;
		cursor: pointer;
		display: inline-block;
		position: relative;
		left: 13px;
		top: 40px;

		img {
			margin-top: calc(80px / 2);
			margin-left: calc(100px / 2);
		}

		.ImgTextCss {
			font-size: 14px;
			font-family: "微软雅黑";
			color: #424e66;
			font-weight: 500;
			margin-left: 30px;
			margin-top: 5px;
		}
	}

	.enclCss1 {
		width: 120px;
		height: 120px;
		background-color: #f7f8fa;
		border: 1px dashed #d4d6d9;
		border-radius: 2px;
		cursor: pointer;
		display: inline-block;
		margin-left: 13px;
		margin-top: 40px;
		position: relative;
	}

	.Mask {
		width: 120px;
		height: 120px;
		background-color: #000;
		opacity: 0.2;
		border-radius: 2px;
		cursor: pointer;
		display: inline-block;
		margin-left: -120px;
		// margin-top: 40px;
		position: relative;

		.phontsD {
			width: 17.21px;
			height: 17.21px;
			position: absolute;
			top: 50px;
			left: 30px;

		}

		.phontsDLook {
			width: 20px;
			height: 20px;
			position: absolute;
			top: 50px;
			left: 50px;

		}

		.phontsDel {
			width: 17.21px;
			height: 17.21px;
			position: absolute;
			top: 50px;
			left: 70px;
		}
	}

	.textCss {
		display: inline-block;
		font-size: 14px;
		font-family: "微软雅黑";
		color: rgb(51, 51, 51);
		position: relative;
		left: 22px;
		top: -60px;
	}

	.textCss2 {
		display: inline-block;
		font-family: "微软雅黑";
		font-size: 14px;
		color: rgb(66, 78, 102);
		position: absolute;
		left: 22px;
		margin-top: 10px;
	}

	.MaskTop {
		// border: 1px solid red;
		width: 120px;
		height: 120px;
		position: relative;
		top: -122px;
		left: 15px;
		background-color: rgba(255, 255, 255, 0.349);
		cursor: no-drop;
	}
</style>